import React from 'react';
import Dashboard from '../../components/plannen/Dashboard';

const PagePlannenDashboard: React.FC = () => {

  return (
    <>
      <Dashboard />
    </>
  );
};

export default PagePlannenDashboard;